import { createContext, useState, useEffect } from "react";
export const NoticeDataContext = createContext({});
export const NoticeDataProvider = function ({ children }) {

  const [nData, setNData] = useState(null);
  const [refreshNData, setRefreshNData] = useState(0);


  return (
    <NoticeDataContext.Provider value={{ nData, setNData, refreshNData, setRefreshNData }}>
      {children}
    </NoticeDataContext.Provider>
  );
};
